"use client";

import React, { useState } from "react";
import styles from "./styles/stem-split-button.module.scss";
import { useStartSplitter } from "@/components/pages/stem-splitter/hooks/use-start-splitter";
import { useStemSplitterContext } from "@/components/pages/stem-splitter/components/providers/stem-splitter-provider";
import CoverTooltip from "@/components/pages/convert/components/cover-tooltip";
import FilledButton from "@/components/common/filled-button";
import { useCreateProcessInputsHandler } from "@/hooks/ai-tool-process/use-create-process-inputs-handler";
import Loader from "@/components/common/loader";

const StemSplitButton = () => {
  const { startSplit } = useStartSplitter();
  const { settings } = useStemSplitterContext();
  const { songFile } = useCreateProcessInputsHandler();
  const [isLoading, setIsLoading] = useState<boolean>();

  const areAnyCategoriesSelected = settings.selectedCategories.length > 0;
  const isAnyUploadedFile = !!songFile;

  const isActive = areAnyCategoriesSelected && isAnyUploadedFile;

  const handleSplitClick = async () => {
    setIsLoading(true);
    try {
      await startSplit({ songFile: songFile, ...settings });
    } finally {
      setIsLoading(false);
    }
  };

  const getTooltipContent = () => {
    if (!!songFile) return "Please select a file to start song splitting";
    if (!areAnyCategoriesSelected) return "Please select any category to split";
  };

  return (
    <div
      className={styles.wrapper}
      data-tooltip-id="splitTooltip"
      data-tooltip-content={getTooltipContent()}
    >
      {(!isAnyUploadedFile || !areAnyCategoriesSelected) && (
        <CoverTooltip id={"splitTooltip"} />
      )}

      <FilledButton
        text={isLoading ? "Uploading file" : "Split Stems"}
        disabled={!isActive || isLoading}
        onClick={handleSplitClick}
        backgroundColor={"#FF5722"}
        color={"#141414"}
        padding={"12px 0"}
        textTransform={"uppercase"}
        showLoadingDots={isLoading}
      />
    </div>
  );
};

export default StemSplitButton;
